import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useApp } from '../../contexts/AppContext';
import { Logo } from '../Common';
import './LoginScreen.css';

const LoginScreen: React.FC = () => {
  const [form] = Form.useForm();
  const { state, login } = useApp();

  const handleSubmit = async (values: { email: string; password: string }) => {
    try {
      await login(values.email, values.password);
    } catch (error) {
      console.error('Login failed:', error);
      message.error(error instanceof Error ? error.message : 'Login failed. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="login-content">
          <div className="login-header">
            <Logo size={48} />
            <h1 className="login-title">Please log in to your account</h1>
          </div>
          
          <div className="dummy-users">
            <h3>Demo Credentials:</h3>
            <div className="credential-item">
              <strong>Admin:</strong> admin@example.com / admin123
            </div>
          </div>

          <Form
            form={form}
            name="login"
            onFinish={handleSubmit}
            layout="vertical"
            className="login-form"
            disabled={state.isLoading}
          >
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' }
              ]}
            >
              <Input 
                placeholder="Email Address"
                size="large"
                className="login-input"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password
                placeholder="Password"
                size="large"
                className="login-input"
                iconRender={(visible) => 
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="login-button"
                loading={state.isLoading}
                block
              >
                Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Card>
    </div>
  );
};

export default LoginScreen;
